// src/components/steps/StepDates.jsx
import React, { useState, useEffect } from 'react';

const StepDates = ({ data, updateData, skip, goBack }) => {
  // Use '' to represent no selection yet
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate]     = useState('');

  // Restore previous picks when coming back
  useEffect(() => {
    if (data.dates?.start) {
      const iso = new Date(data.dates.start).toISOString().slice(0, 10);
      setStartDate(iso);
    }
    if (data.dates?.end) {
      const iso = new Date(data.dates.end).toISOString().slice(0, 10);
      setEndDate(iso);
    }
  }, [data.dates]);

  // Compute Date objects
  const startValid = !!startDate;
  const endValid   = !!endDate;
  const startObj   = startValid ? new Date(startDate) : null;
  const endObj     = endValid   ? new Date(endDate)   : null;

  // Disable Next until valid and end >= start
  const isNextDisabled = !startObj || !endObj || endObj < startObj;

  const handleNext = () => {
    if (isNextDisabled) return;
    updateData('dates', {
      start: new Date(startDate).toISOString(),
      end:   new Date(endDate).toISOString(),
    });
  };

  return (
    <div className="bg-white/60 backdrop-blur p-6 rounded-xl shadow-lg max-w-md mx-auto">
      <h2 className="text-xl font-semibold mb-4">Select Your Travel Dates</h2>

      <div className="mb-6">
        <h3 className="font-medium mb-2">Start Date</h3>
        <input
          type="date"
          value={startDate}
          onChange={e => setStartDate(e.target.value)}
          className="w-full border rounded-lg p-2"
        />
      </div>

      <div className="mb-6">
        <h3 className="font-medium mb-2">End Date</h3>
        <input
          type="date"
          value={endDate}
          onChange={e => setEndDate(e.target.value)}
          className="w-full border rounded-lg p-2"
        />
        {startObj && endObj && endObj < startObj && (
          <p className="mt-2 text-sm text-red-600">
            End date can’t be before start date.
          </p>
        )}
      </div>

      <div className="flex justify-between items-center">
        {goBack && (
          <button
            onClick={goBack}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
          >
            Back
          </button>
        )}
        <div className="flex items-center space-x-2">
          <button
            onClick={handleNext}
            disabled={isNextDisabled}
            className={`px-6 py-2 rounded-lg transition \
              ${isNextDisabled
                ? 'bg-blue-300 text-white cursor-not-allowed'
                : 'bg-blue-600 text-white hover:bg-blue-700'}`}
          >
            Next
          </button>
          <button
            onClick={skip}
            className="px-6 py-2 bg-transparent border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition"
          >
            Skip
          </button>
        </div>
      </div>
    </div>
  );
};

export default StepDates;
